import EventBus from "@plugins/common/service/eventbus";

const MentionEventBus = new EventBus();
export default MentionEventBus;
